import Image from 'next/image';

import type { RankingImage } from '../types';
import { RichText } from './RichText';

interface EditorialImageProps {
  image: RankingImage;
}

export const EditorialImage = (props: EditorialImageProps) => {
  const { image } = props;

  return (
    <figure className="m-0 max-w-2xl">
      <Image
        src={image.src}
        alt={image.alt}
        width={image.width}
        height={image.height}
        loading="lazy"
        unoptimized
        className="h-auto w-full rounded-2xl border border-secondary-200 object-cover"
      />
      <figcaption className="mt-3 text-sm leading-relaxed text-secondary-700">
        {image.caption}
        {image.credit != null ? (
          <span className="mt-1 block text-xs text-secondary-500">
            <RichText text={image.credit} />
          </span>
        ) : null}
      </figcaption>
    </figure>
  );
};
